import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FileUploadOutlined } from "@mui/icons-material";

import { MTable } from "../v3";
import { columnHeaders } from "../../pages/stock/constants";
import { StockService } from "../../services";

export const YardList = () => {
  const [yards, setYards] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [paginationState, setPaginationState] = useState({
    page: 0,
    pageSize: 10,
  });

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (filters) => {
    try {
      setLoading(true);
      const response = await StockService.getYards(filters);
      setYards(response);
      setLoading(false);
    } catch (error) {
      console.error(`🚀 ~ fetchData ~ error:`, error);
      toast.error("Error fetching data");
    }
  };

  const handleSearchChange = (searchValue) => {
    setSearchText(searchValue);
    fetchData({
      page: paginationState.page + 1,
      limit: paginationState.pageSize,
      searchText: searchValue,
    });
  };
  const handleExportClick = () => {
    // Implement export functionality here
  };

  const handlePaginationChange = (model) => {
    setPaginationState(model);
    fetchData({
      page: paginationState.page + 1,
      limit: paginationState.pageSize,
      searchText: searchText,
    });
  };

  const onYardClick = (yard) => {
    navigate(`/yards/${yard.id}`);
  };

  //   hard coded datas from constants file
  const rows = yards.map((yard, index) => {
    return {
      sl: index + 1,
      id: index + 1,
      yardName: yard.yardName,
      yardLocation: yard.yardLocation,
    };
  });

  return (
    <MTable
      placeholder="search yard"
      searchText={searchText}
      onSearchChange={handleSearchChange}
      showSearchBar
      // Export Button data
      buttonText="Export"
      buttonIcon={FileUploadOutlined}
      onExportClick={handleExportClick}
      showExportButton
      // Table data
      columnHeaders={columnHeaders}
      tableRows={rows}
      rowCount={yards.length || 0}
      loading={loading}
      paginationModel={paginationState}
      onPaginationChange={handlePaginationChange}
      onRowClick={onYardClick}
    />
  );
};
